import React, { useEffect, useState } from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { media } from '../../../utils/media-queries';
import { useWindowSize } from '../../../hooks/useWindowSize';
import Tags from '../../molecules/tags';
import CtaLink from '../../atoms/ctaLink';

const JournalCTA = ({
  imageSrc,
  alt,
  overline,
  headline,
  copy,
  slug,
  tags,
  isJournalLanding = false,
  onClick,
  journalEntry,
  activeTags,
  setActiveTags,
}) => {
  const size = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (size.width < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [size]);

  const [hover, setHover] = useState();

  return (
    <StyledJournalCTA className="grid">
      <div className="grid">
        <div className="text">
          <div>
            <Link
              to={`/journal/${slug}`}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setTimeout(() => setHover(false), 2000)}
            >
              <p className="overline" style={{ paddingBottom: isMobile && 0 }}>
                {overline}
              </p>
            </Link>
            <div className="top">
              <Link
                to={`/journal/${slug}`}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setTimeout(() => setHover(false), 2000)}
              >
                <p className="bold-small">{headline}</p>
              </Link>
              <Tags
                tags={tags}
                onClick={onClick}
                journalEntry={journalEntry}
                activeTags={activeTags}
                setActiveTags={setActiveTags}
              />
            </div>
          </div>
          <div>
            <Link
              to={`/journal/${slug}`}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setTimeout(() => setHover(false), 2000)}
            >
              <p className="copy">{copy}</p>
            </Link>
            <div className="links">
              <CtaLink
                link={`journal/${slug}`}
                ctaText="Read Journal Entry"
                active={hover}
              />
              {!isJournalLanding && (
                <CtaLink link="journal" ctaText="Visit the Kwera Journal" />
              )}
            </div>
          </div>
        </div>
        <figure>
          <Link
            to={`/journal/${slug}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setTimeout(() => setHover(false), 2000)}
          >
            <Img fluid={imageSrc} alt={alt} />
          </Link>
        </figure>
        <div className="top-mobile">
          <p className="bold-small">{headline}</p>
          <Tags tags={tags} onClick={onClick} />
          <div className="links-mobile">
            <CtaLink
              link={`journal/${slug}`}
              ctaText="Read Journal Entry"
              active={hover}
            />
            {!isJournalLanding && (
              <CtaLink
                link="journal"
                ctaText="Visit the Kwera Journal"
                style={{ marginTop: 'var(--spacing-XXS)' }}
              />
            )}
          </div>
        </div>
      </div>
    </StyledJournalCTA>
  );
};

const StyledJournalCTA = styled.section`
  margin-bottom: calc(var(--v-spacing-L) * 3);

  .top {
    display: none;
  }

  .bold-small {
    padding-bottom: var(--v-spacing-S);
  }

  .links {
    display: none;
  }

  .copy {
    font-size: var(--font-size-2);
  }

  figure {
    min-height: 90vw;
    max-height: 90vw;
    .gatsby-image-wrapper {
      min-height: 90vw;
      max-height: 90vw;
    }
  }

  @media ${media.L} {
    .top {
      display: block;
    }

    .top-mobile {
      display: none;
    }

    figure {
      grid-column: 14 / 25;
      min-height: 43vw;
      max-height: 43vw;
      .gatsby-image-wrapper {
        min-height: 43vw;
        max-height: 43vw;
      }
    }

    .links-mobile {
      display: none;
    }

    .links {
      display: flex;
      flex-direction: column;
    }

    .text {
      grid-column: 1 / 14;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .copy {
      font-size: var(--font-size-1);
    }
  }

  @media ${media.XL} {
    .text {
      grid-column: 1 / 12;
    }
  }
`;

JournalCTA.propTypes = {
  imageSrc: PropTypes.object,
  alt: PropTypes.string,
  overline: PropTypes.string,
  headline: PropTypes.string,
  copy: PropTypes.string,
  slug: PropTypes.string,
  tags: PropTypes.array,
  isJournalLanding: PropTypes.bool,
  onClick: PropTypes.func,
  journalEntry: PropTypes.bool,
  activeTags: PropTypes.array,
  setActiveTags: PropTypes.func,
};

export default JournalCTA;
